import React, { Component } from "react";
import ReactDOM from "react-dom";

// import '../../style/Auth.css';

// div.auth-container { max-width: 40em; margin: 0 auto 0 0; }
// div.auth-container ul.auth-flows { list-style-type: none; display: flex; margin: 1.5em 0 0 0; padding: 0; }
// div.auth-container ul.auth-flows li { flex: 1; max-width: 4em; margin:0; }
// div.auth-container ul.auth-flows li a { cursor: pointer; color: blue; text-decoration: underline; }
// div.auth-container li { display: flex; margin: 0 0 1em 0; flex-wrap: wrap;}
// div.auth-container li>label,li>div { min-width: 5em; }
// div.auth-container li>label { flex: 2; }
// div.auth-container li>div { flex: 5; }

// div.auth-container li>label {font-size: 1.3em;text-align: right; padding: 0.2em 0.5em 0 0; font-weight: bold;}
// div.auth-container li>div>input { max-width: 15em; width: 100%; font-size: 1.3em; line-height: 1.3em; }
// div.auth-container li>div>button { font-size: 1.3em; }

// div.auth-container div.errors {  text-align: center; background: rgba(255, 0, 0, 0.15); padding: 0.3em; margin: 1em auto; font-weight: bold;}

// @media (min-width: 500px) {
//   div.auth-container div.errors { max-width: 50%; }
// }
import customPropTypes from "material-ui/utils/customPropTypes";
import { createStyleSheet } from "material-ui/styles";

const styleSheet = createStyleSheet("AuthForm", (theme) => {
  window.theme = theme;
  return {
    root: {
      maxWidth: "40em",
      margin: "0 auto 0 0",

      "& ul": {
        "& li": {
          display: "flex",
          flex: 1,
          margin: "0 0 1em 0",
          flexWrap: "wrap",
          "& label": {
            minWidth: "5em",
            flex: 2,
            fontSize: "1.3em",
            textAlign: "right",
            padding: "0.2em 0.5em 0 0",
            fontWeight: "bold",
          },
          "& div": {
            minWidth: "5em",
            flex: 5,
            "& button": {
              fontSize: "1.3em",
            },
            "& input": {
              maxWidth: "15em",
              width: "100%",
              fontSize: "1.3em",
              lineHeight: "1.3em",
            },
          },
        },
      },
    },
    errors: {
      textAlign: "center",
      background: "rgba(255, 0, 0, 0.15)",
      padding: "0.3em",
      margin: "1em auto",
      fontWeight: "bold",
    },
  };
});

// FORM SUPERCLASS (wraps form elements in styled html structure)
export default class AuthForm extends Component {
  static contextTypes = {
    styleManager: customPropTypes.muiRequired,
  };
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    if (this.refs.autoFocus) ReactDOM.findDOMNode(this.refs.autoFocus).focus();
  }

  submitWrapper(fn) {
    return (e) => {
      e.preventDefault();
      return fn(this.state);
    };
  }

  errorsExist() {
    return !!(
      this.props.validationErrors && this.props.validationErrors.length
    );
  }

  renderErrors() {
    return {
      __html:
        this.props.validationErrors &&
        this.props.validationErrors.join("<br />"),
    };
  }

  render() {
    const classes = this.context.styleManager.render(styleSheet);

    let formElements = this.components.map((c, n) => {
      // button calls onSubmit prop
      if (c.component.type === "button") {
        c.component = React.cloneElement(c.component, {
          onClick: this.submitWrapper(this.props.onSubmit),
          disabled: this.props.isSpinning,
        });
      }

      // add "controlled form" event handlers
      if (c.component.type === "input") {
        c.component = React.cloneElement(c.component, {
          disabled: this.props.isSpinning,
          onChange: (e) => {
            let tmpObj = {};
            tmpObj[c.id] = e.target.value;
            this.setState(tmpObj);
          },
          value: this.state[c.id] || "",
        });
      }

      return (
        <li key={n}>
          <label htmlFor={c.id}>{c.label}</label>
          <div>{c.component}</div>
        </li>
      );
    });

    return (
      <div>
        <div className={classes.root}>
          {this.errorsExist() ? (
            <div
              className={classes.errors}
              dangerouslySetInnerHTML={this.renderErrors()}
            />
          ) : null}

          <form>
            <ul>{formElements}</ul>
          </form>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/lib/AuthForm.js